<template>
  <div class="footer">
    <p>Copyright © {{new Date().getFullYear()}} 读者之星（天津）网络科技有限公司 版权所有</p>
    <p>津ICP备2021009257号</p>
  </div>
</template>
<script>
export default {
  name: 'Footer'
}
</script>
<style scoped>
  .footer {
    bottom: 0;
    left: 0;
    background-color: #fff;
    width: 100%;
    height: 131px;
    font-size: 17px;
    text-align: center;
    line-height: 35px;
    color: #666;
    padding-top: 30px;
  }
</style>
